/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExerciseSide {
    LEFT = 'Left',
    RIGHT = 'Right',
}